import CustomDialog from '@/components/custom-dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { SlidersHorizontal } from 'lucide-react';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import {
    AdvanceFormItemProps,
    AdvanceFormProps,
    advanceSearchBtnProps,
    BaseFormValues,
} from '../table-ag-types';

// const onRenew = () => {
//     setAdvanceSearchValue(initAdvanceSearchValue);
// };
// const onApply = () => {
//     setPageInfo((state) => ({
//         ...state,
//         pageNumber: 1,
//         filters: [
//             {
//                 key: 'Name',
//                 values: [advanceSearchValue.Unit],
//                 logicalOperator: LogicalOperator.Or,
//                 operatorType: OperatorType.Regex,
//             },
//         ],
//     }));
// };
// const advanceFilter: TableAdvanceSearch<{
//     Unit: '';
// }> = {
//     btns: [
//         {
//             name: lngDef('ReNew'),
//             onClick: onRenew,
//             className: 'flex items-center gap-x-2',
//         },
//         {
//             name: lngDef('Apply'),
//             onClick: onApply,
//             className: 'flex items-center gap-x-2',
//         },
//     ],
//     content: [
//         {
//             type: 'Grid',
//             wrapperClassName: 'grid-cols-12',
//             children: [
//                 {
//                     name: 'type',
//                     label: 'Don vi',
//                     required: true,
//                     wrapperClassName: 'col-span-12 md:col-span-6',
//                     labelClassName: 'mb-2 cursor-pointer block',
//                     children: (
//                         <Input
//                             id='type'
//                             onChange={(e) =>
//                                 onChangeAdvanceSearchValue(
//                                     'Unit',
//                                     e.target.value
//                                 )
//                             }
//                             value={advanceSearchValue?.Unit ?? ''}
//                         />
//                     ),
//                 },
//             ],
//         },
//     ],
// };

const AdvanceForm = <T extends BaseFormValues>(props: AdvanceFormProps<T>) => {
    const { content } = props;
    if (!content) {
        return <React.Fragment />;
    }

    const _loop = (data: AdvanceFormItemProps<T>) => {
        return data.map(({ name, type: itemType, ...rest }, idx) => {
            if (itemType === 'Grid' || itemType === 'Flex') {
                const isFormItemProps = (child: any) => {
                    return (
                        Array.isArray(child) && typeof child?.[0] === 'object'
                    );
                };
                if (isFormItemProps(rest.children)) {
                    let _rootCls = 'grid grid-cols-2 gap-x-2';
                    if (itemType === 'Flex') {
                        _rootCls = 'flex items-center gap-x-2';
                    }

                    return (
                        <div
                            key={name}
                            className={cn(_rootCls, rest.wrapperClassName)}
                        >
                            {_loop(rest.children as AdvanceFormItemProps<T>)}
                        </div>
                    );
                }
            } else {
                return name ? (
                    <div className={cn('mb-4', rest.wrapperClassName)}>
                        <Label
                            className={cn('text-sm', rest.labelClassName)}
                            htmlFor={name}
                        >
                            {rest.label}
                        </Label>
                        <div>
                            {React.isValidElement(rest.children)
                                ? rest.children
                                : null}
                        </div>
                        <div className={cn('', rest.descriptionClassName)}>
                            {rest.description}
                        </div>
                        <div className={cn('', rest.errorClassName)}>
                            {rest.error}
                        </div>
                    </div>
                ) : (
                    <></>
                );
            }
        });
    };

    return (
        <div>
            <div className={cn('rls')}>{_loop(content)}</div>
        </div>
    );
};

const TableAdvanceSearch = ({
    renderAdvanceSearch,
}: {
    renderAdvanceSearch: any;
}) => {
    const transDef = useTranslations('System');
    const [isShowModalAdvanceSearch, setIsShowModalAdvanceSearch] =
        useState<boolean>(false);

    return (
        <CustomDialog
            headerTitle={
                <div className='flex items-center gap-x-2'>
                    <h1>{transDef('System_FilterData')}</h1>
                </div>
            }
            trigger={
                <Button variant='outline'>
                    <SlidersHorizontal size={16} className='mr-1' />{' '}
                    {transDef('System_FilterData')}
                </Button>
            } // ẩn nút toggle
            dialogProps={{
                open: isShowModalAdvanceSearch,
                onOpenChange: setIsShowModalAdvanceSearch,
            }} // custom status open, onChangeOpen
            classNameContent='min-w-[50vw]'
            cancel={{ children: transDef('System_Close') }}
            footer={
                <div className='flex min-w-[43vw] justify-between'>
                    {renderAdvanceSearch.btns.map(
                        (btn: advanceSearchBtnProps, i: number) => {
                            return (
                                <Button
                                    key={i}
                                    onClick={btn.onClick}
                                    className={btn.className}
                                >
                                    {btn.name}
                                </Button>
                            );
                        }
                    )}
                </div>
            }
        >
            <AdvanceForm content={renderAdvanceSearch.content} />
        </CustomDialog>
    );
};

export default TableAdvanceSearch;
